import styled from 'styled-components'

import { AnchorButton } from 'components/anchor-button'
import { Section } from 'components/general-styles/General'
import { theme } from 'styles/theme'
const { borderWidths, colors, media, space, fontSizes, lineHeights, radii, transitions } = theme

export const Quicklinks = styled(Section).attrs({as: 'footer',})`
  color: ${colors['blue-text-strong']};
  padding: ${space['spacing-mega']} 0;

  hr {
    background: #555B66;
    height: 1px;
    margin: ${space['spacing-xxl']} 0;
  }

  @media (${media.phone}) {
    .accordion-support span {
      margin: 0;
      color: ${colors['blue-text-strong']};
    }
  }

  li > a,
  li > a:visited {
    color: inherit;
    cursor: pointer;
    line-height: ${lineHeights['font-line-height-lg']};
    font-size: ${fontSizes['font-size-body-2']};

    &::after {
      border-bottom-color: ${colors['neutral-background-default']};
    }
  }
`

export const AccordionLinks = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['spacing-sm']};
  margin: ${space['spacing-sm']} 0;
`

export const LogoWrapper = styled.div`
  margin-bottom: ${space['spacing-md']};
`

export const LinksSection = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['spacing-sm']};
  width: 25%;

  > p:not(:first-child) {
    margin-top: ${space['spacing-mega']};
  }
`

export const Links = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${space['spacing-sm']};
  width: 100%;

  &:last-child {
    margin-top: ${space['spacing-xxl']};
  }

  @media (${media.phone}) {
    flex-direction: column;
  }
`

export const LinkList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['spacing-sm']};
`

export const Address = styled.address`
  font-style: normal;
  text-align: center;
  white-space: pre-wrap;
`

export const Social = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${space['spacing-xs']};

  a {
    all: unset;
    cursor: pointer;

    &::after {
      content: none;
    }
  }

  @media (${media.tablet}) {
    gap: ${space['spacing-xxs']};
  }

  @media (${media.desktop}) {
    gap: ${space['spacing-xs']};
  }
`

export const ContactButton = styled(AnchorButton)`
  justify-content: center;
  border: ${borderWidths['border-stroke-micro']} solid currentcolor;
  border-radius: ${radii['corner-radius-pill']};
  background: transparent;
  color: ${colors['blue-text-strong']};
  transition: ${transitions.default};

  &:hover {
    background: ${colors['blue-text-strong']};
    color: ${colors['neutral-text-default']};
  }

  @media (${media.phone}) {
    margin-top: ${space['spacing-md']};
  }
`
